import React, {Component, Fragment} from 'react'
import {
    Row,
    Col,
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
} from 'reactstrap'
import Select from 'react-select'
import CustomSelectInput from 'components/CustomSelectInput'
import autobind from 'auto-bind'
import * as API from 'SDK/api'

export default class extends Component {
    constructor(props) {
        super(props)
        autobind(this)
    }
    async remove() {
        try {
            let response = await API.remove(
                'nodes/' + this.props.editingNode.nodeId,
                2
            )
            if (response.success) {
                this.props.toggleModal('removeModal')
            } else {
                return alert(
                    'There was an error deleting this Gateway. Please try again later.'
                )
            }
        } catch (error) {
            console.log(error)
            return alert(
                'There was an error deleting this Gateway. Please try again later.'
            )
        }
    }
    componentWillMount() {}
    componentWillUnmount() {}

    render() {
        let {modal, toggleModal} = this.props
        return (
            <Fragment>
                <Modal
                    isOpen={modal}
                    toggle={() => {
                        toggleModal('removeModal')
                    }}>
                    <ModalHeader
                        toggle={() => {
                            toggleModal('removeModal')
                        }}>
                        Remove Gateway
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col xs="12">
                                <p>
                                    Are you sure you want to remove this
                                    Gateway?
                                </p>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={() => {
                                toggleModal('removeModal')
                            }}>
                            Cancel
                        </Button>
                        <Button color="danger" onClick={this.remove}>
                            Remove
                        </Button>
                    </ModalFooter>
                </Modal>
            </Fragment>
        )
    }
}
